import { useCallback } from 'react'
import { register } from 'utils/notification-wrapper'
import { registerDevice } from 'utils/notifications'
import { unsafeGetToken } from 'ducks/auth'
import { transitions } from '@adalo/constants'

export const useNotificationSetup = ({
  app,
  authenticated,
  getNotificationsURL,
  isPreviewer,
  showNotification,
  dispatch,
  initialComponentId,
  getRoute,
  navigate,
}) => {
  const handleRegister = useCallback(
    async deviceId => {
      let actualDeviceId = deviceId
      if (deviceId && deviceId.token) {
        actualDeviceId = deviceId.token
      }

      dispatch({
        type: 'SET_DEVICE_ID',
        payload: { deviceId: actualDeviceId },
      })

      if (authenticated) {
        try {
          await registerDevice(
            app,
            actualDeviceId,
            getNotificationsURL?.(),
            unsafeGetToken(null, app),
            isPreviewer
          )
        } catch (error) {
          console.error('device registration failed:', error)
        }
      }
    },
    [app, authenticated, getNotificationsURL, isPreviewer, dispatch]
  )

  const handleNotificationSub = useCallback(
    route => {
      // Use navigate instead of direct dispatch
      if (route && route.target) {
        navigate({
          ...route,
          transition: transitions.PUSH,
        })
      }
    },
    [navigate]
  )

  const handleForegroundNotification = useCallback(
    (route, notif) => {
      showNotification(notif, () => {
        handleNotificationSub(route)
      })
    },
    [showNotification, handleNotificationSub]
  )

  const handleNotification = useCallback(
    (route, notif = null) => {
      if (notif) {
        return handleForegroundNotification(route, notif)
      } else {
        return handleNotificationSub(route)
      }
    },
    [handleForegroundNotification, handleNotificationSub]
  )

  const setupNotifications = useCallback(
    (skipNotifications, deviceId, getWebNotificationConfig) => {
      if (!skipNotifications) {
        register(
          {
            onRegister: handleRegister,
            onNotification: handleNotification,
          },
          getWebNotificationConfig?.()
        )
      } else if (deviceId) {
        handleRegister(deviceId, true)
      }
    },
    [handleRegister, handleNotification]
  )

  return {
    handleRegister,
    handleNotification,
    handleNotificationSub,
    handleForegroundNotification,
    setupNotifications,
  }
}
